import { render } from "./Recipients.vue?vue&type=template&id=633ccd86"
import script from "./Recipients.vue?vue&type=script&lang=js"
export * from "./Recipients.vue?vue&type=script&lang=js"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__